import { _DOCUMENT_ } from "constants/dom";

function createElement<K extends keyof HTMLElementTagNameMap>(
  tagName: K,
  options?: ElementCreationOptions
): HTMLElementTagNameMap[K] {
  return _DOCUMENT_.createElement(tagName, options);
}

export default createElement;
